import React, { Fragment } from 'react';

import Notification from '../Notification/Notification';
import Link from '../../../../../components/NextJs/Link/Link';

interface Props {
    conditionSlug: string;
    outOfStockMessage?: string;
}

/**
 * Notification to the user that the given treatment is out of stock.
 */
const OutOfStockNotification = ({ conditionSlug, outOfStockMessage }: Props) => (
    <Notification>
        {outOfStockMessage
            ? <p dangerouslySetInnerHTML={{ __html: outOfStockMessage }} />
            : (
                <Fragment>
                    This item is out of stock,{' '}
                    <Link href={`/${conditionSlug}`} className="type-link">find alternatives here</Link>
                </Fragment>
            )
        }
    </Notification>
)

export default OutOfStockNotification;
